import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-work-based-learning',
  imports: [PillarPagesTemp],
  templateUrl: './work-based-learning.html',
  styleUrl: './work-based-learning.scss',
})
export class WorkBasedLearning {

}
